import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

if (!process.env.VUE_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
  throw new Error('VUE_APP_SENTRY_DSN is not set');
}

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new VueIntegration({ Vue, attachProps: true })],
});

const helpers = {
  captureException(e) {
    if (!process.env.VUE_APP_SENTRY_DSN) {
      console.error(e);
    } else {
      Sentry.captureException(e);
    }
  },
};

export default {
  install() {
    Vue.sentry = helpers;
    Vue.prototype.$sentry = helpers;
  },
};
